import { render, staticRenderFns } from "./CopyPasteMicrosoftTeams.vue?vue&type=template&id=66fb2846&"
import script from "./CopyPasteMicrosoftTeams.vue?vue&type=script&lang=js&"
export * from "./CopyPasteMicrosoftTeams.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QBtn,QTooltip});
